import { useState } from "react";
import { Button } from "react-bootstrap";
import { GrNext, GrPrevious } from "react-icons/gr";
import { Link } from "react-router-dom";

const BooksChapters = ({ checkSubs, bookschap }) => {


    const [currentIndex, setCurrentIndex] = useState(0);

    // Current chapter ka data
    const currentChapter = bookschap[currentIndex];

    // Next Chapter
    const nextChapter = () => {
        if (currentIndex < bookschap.length - 1) {
            setCurrentIndex(currentIndex + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' }); // 👈 Add this line

        }
    };

    // Previous Chapter
    const prevChapter = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' }); // 👈 Add this line
        }
    };


    return (
        <div className="container px-5 my-5 book-detail">
            <div className="row justify-content-around">

                <div className="col-lg-auto" >
                    <div
                        style={{ backgroundImage: `url(${currentChapter?.image_file})` }}
                        className="background-image-blur audio-book-background card position-relative p-4 book-detail-card d-flex justify-content-center border-0 align-items-center"
                    >

                        <div className="foreground-content">

                            <img className='detail-image' src={currentChapter?.image_file} alt="" />

                        </div>
                    </div>



                </div>
                <div className="col-lg-6">
                    <h2 className="s-30 fw-600 mb-3">
                        {currentChapter?.heading || "No Chapter"}
                    </h2>
                    <p className="fw-300">{currentChapter?.content || "No Content"}</p>
                    <hr />

                    {/* Navigation Buttons */}

                    {
                        checkSubs === null ? (
                            <>
                                <Button as={Link} to={"/subscription"} className="btn-danger w-100">Subscribe </Button>
                            </>
                        ) :
                            (<>
                                <div className="d-flex justify-content-between">
                                    <button
                                        className="btn btn-danger rounded-circle d-flex justify-content-center align-items-center"
                                        style={{ width: "50px", height: "50px" }}
                                        onClick={prevChapter}
                                        disabled={currentIndex === 0}
                                    >
                                        <GrPrevious size={22} />

                                    </button>
                                    <button
                                        className="btn btn-danger rounded-circle d-flex justify-content-center align-items-center"
                                        style={{ width: "50px", height: "50px" }}
                                        onClick={nextChapter}
                                        disabled={currentIndex === bookschap.length - 1}
                                    >
                                        <GrNext size={22} />

                                    </button>
                                </div>
                            </>)
                    }
                </div>
            </div>
        </div>
    );
};

export default BooksChapters;
